import { render, staticRenderFns } from "./BanUser.vue?vue&type=template&id=2d16d31c&scoped=true"
import script from "./BanUser.vue?vue&type=script&lang=js"
export * from "./BanUser.vue?vue&type=script&lang=js"
import style0 from "./BanUser.vue?vue&type=style&index=0&id=2d16d31c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d16d31c",
  null
  
)

export default component.exports